import format from 'date-fns/format';
import isDate from 'lodash/isDate';
import { DEFAULT_DATE_PATTERN } from '../../../../_internal/constants';

const formatDate = (date, pattern = DEFAULT_DATE_PATTERN, defaultString = '') =>
  isDate(date) ? format(date, pattern) : defaultString;

export default formatDate;
